module.exports = __webpack_public_path__ + "img/i_media_matrix-1.08ee3bf4.png";